module.exports = __webpack_public_path__ + "static/media/blog_grid_2.09248d2f.jpg";